import {
  handleBondsInstrumentState,
  handleMutualFundsInstruments,
} from 'redux/store/assetClass';
import {handleUpdateBond, handleUpdateMutualFund} from '../actions';
import {
  UPDATE_BOND,
  UPDATE_MUTUAL_FUND,
} from 'graphql/mutations/assetManagement';
import {possibleInstrumentRouteKeys} from './constants';
import {checkExactRoute} from 'utils/helper';
import {
  createBondsInstrumentRoute,
  createBondsStepTwoRoute,
  createMutualFundsRoute,
  createMutualFundsStepTwoRoute,
} from '../Bonds/routes';
import {
  GET_BOND_INSTRUMENT_BY_LANGUAGE,
  GET_MUTUAL_FUND_BY_LANGUAGE,
  GET_IPO_BY_ID,
  GET_PUBLIC_EQUITY_BY_ID,
} from 'graphql/queries/assetManagement';
import {
  handleEquityInstruments,
  handleIpoInstruments,
} from 'redux/store/assetClass';
import {handleUpdateEquity, handleUpdateIpo} from '../actions';
import {
  UPDATE_IPO,
  UPDATE_PUBLIC_EQUITY,
} from 'graphql/mutations/assetManagement';
import {
  createEquityRoute,
  createEquityStepTwoRoute,
  createIpoRoute,
  createIpoStepTwoRoute,
} from '../Equities/routes';

export const financialInstrumentConfig = {
  bond: {
    overviewSelector: state => state?.assetClass?.bondInstruments,
    handleDispatch: handleBondsInstrumentState,
    handleUpdate: handleUpdateBond,
    mutation: UPDATE_BOND,
    title: 'Bond',
    route: createBondsInstrumentRoute,
    stepTwoRoute: createBondsStepTwoRoute,
    QUERY: GET_BOND_INSTRUMENT_BY_LANGUAGE,
  },
  'mutual-funds': {
    overviewSelector: state => state?.assetClass?.mutualFundsInstruments,
    handleDispatch: handleMutualFundsInstruments,
    handleUpdate: handleUpdateMutualFund,
    mutation: UPDATE_MUTUAL_FUND,
    title: 'Mutual Fund',
    route: createMutualFundsRoute,
    stepTwoRoute: createMutualFundsStepTwoRoute,
    QUERY: GET_MUTUAL_FUND_BY_LANGUAGE,
  },
  ipo: {
    overviewSelector: state => state?.assetClass?.ipoInstruments,
    handleDispatch: handleIpoInstruments,
    handleUpdate: handleUpdateIpo,
    mutation: UPDATE_IPO,
    title: 'IPO',
    route: createIpoRoute,
    stepTwoRoute: createIpoStepTwoRoute,
    QUERY: GET_IPO_BY_ID,
  },
  'public-equity': {
    overviewSelector: state => state?.assetClass?.equityInstruments,
    handleDispatch: handleEquityInstruments,
    handleUpdate: handleUpdateEquity,
    mutation: UPDATE_PUBLIC_EQUITY,
    title: 'Public equity',
    route: createEquityRoute,
    stepTwoRoute: createEquityStepTwoRoute,
    QUERY: GET_PUBLIC_EQUITY_BY_ID,
  },
};

export const currentInstrumentKey = path => {
  return possibleInstrumentRouteKeys.filter(key =>
    checkExactRoute(path, key),
  )[0];
};
